import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { OFFER_STATUS_APPROVE, OFFER_STATUS_NOT_APPROVE, OFFER_STATUS_SELECTION, } from '../../../../../../../define/consts/rfp';
import { propBool, propFunc, propId, propShape, } from '../../../../../../../helpers/custom-prop-types';
const ActionColumn = (props) => {
    const { driverTargetRef, isActiveDriverTarget, isDisabled, onClickDriverTarget, onClickSendOff: rawOnClickSendOff, rfpId, viewRequest, } = props;
    const { offer: { status }, } = viewRequest;
    const onClickSendOff = useCallback(() => {
        rawOnClickSendOff(viewRequest);
    }, [viewRequest, rawOnClickSendOff]);
    if (status === OFFER_STATUS_SELECTION.value) {
        return (_jsxs("div", Object.assign({ className: clsx('action_column', isActiveDriverTarget && 'is-driver-active'), onClick: isActiveDriverTarget ? onClickDriverTarget : undefined, ref: driverTargetRef, role: 'presentation' }, { children: [_jsx("button", Object.assign({ className: 'button normal', disabled: isDisabled, onClick: onClickSendOff, type: 'button' }, { children: "\u9762\u8AC7\u3092\u898B\u9001\u308B" })), _jsx(Link, Object.assign({ className: clsx('button', 'service', {
                        disabled: isDisabled,
                        event_none: isDisabled,
                    }), to: `/project/client/${rfpId}/interview/input?id=${viewRequest.id}` }, { children: "\u9762\u8AC7\u65E5\u7A0B\u3092\u6C7A\u3081\u308B" }))] })));
    }
    if (status === OFFER_STATUS_APPROVE.value) {
        return (_jsx("div", Object.assign({ className: clsx('action_column', isActiveDriverTarget && 'is-driver-active'), onClick: isActiveDriverTarget ? onClickDriverTarget : undefined, ref: driverTargetRef, role: 'presentation' }, { children: _jsx("span", Object.assign({ className: 'approve_label' }, { children: "\u9762\u8AC7\u65E5\u7A0B\u3092\u9001\u4ED8\u3057\u307E\u3057\u305F" })) })));
    }
    if (status === OFFER_STATUS_NOT_APPROVE.value) {
        return (_jsx("div", Object.assign({ className: clsx('action_column', isActiveDriverTarget && 'is-driver-active'), onClick: isActiveDriverTarget ? onClickDriverTarget : undefined, ref: driverTargetRef, role: 'presentation' }, { children: _jsx("span", Object.assign({ className: 'not_approve_label' }, { children: "\u9762\u8AC7\u3092\u898B\u9001\u308A\u307E\u3057\u305F" })) })));
    }
    return null;
};
ActionColumn.propTypes = {
    driverTargetRef: propShape(),
    isActiveDriverTarget: propBool(),
    isDisabled: propBool().isRequired,
    onClickDriverTarget: propFunc(),
    onClickSendOff: propFunc().isRequired,
    rfpId: propId().isRequired,
    viewRequest: propShape().isRequired,
};
ActionColumn.defaultProps = {
    driverTargetRef: null,
    isActiveDriverTarget: false,
    onClickDriverTarget: undefined,
};
export default ActionColumn;
